import { take } from "../util/takePayload";
export const getNewAggregatedEventSales = () => ({
    salesData: {
        totalSales: 0,
        totalSalesLimit: 0,
        ticketsSold: 0,
        totalTickets: 0,
        totalTicketsSalesToday: 0,
        totalTicketsSoldToday: 0,
    },
});
export const fromGql = (gqlEventSales) => ({
    salesData: Object.assign({}, take(gqlEventSales.salesData, 'totalSales', 'totalSalesLimit', 'ticketsSold', 'totalTickets', 'totalTicketsSalesToday', 'totalTicketsSoldToday')),
});
export const fromGqlCollection = (gqlEventSalesCollection) => (gqlEventSalesCollection !== null && gqlEventSalesCollection !== void 0 ? gqlEventSalesCollection : []).map(fromGql);
//# sourceMappingURL=AggregatedEventSales.js.map